/* eslint-disable react/forbid-prop-types */
import React from 'react';
import './styles.scss';
import PropTypes from 'prop-types';

const InputsWrap = ({ children, labelTitle }) => (
  <div className="form__radio-wrap">
    <p className="form__radio-label">{labelTitle}</p>
    <div className="form__radio-inputs">
      {children}
    </div>
  </div>
);

const InputRadio = ({
  labelText,
  inputName, hasError, inputId, checked, disabled, onChange,

}) => (
  <>

    <div className="form-check form-check-inline">
      <input className={`form-check-input ${hasError && 'is-invalid'}`} disabled={disabled} type="radio" checked={checked} name={inputName} id={inputId} onChange={onChange} />
      <label className="form-check-label" htmlFor={inputId}>
        {labelText}
      </label>
    </div>
  </>
);
const EpFormRadio = {
  Wrap: InputsWrap,
  Input: InputRadio,
};

export default EpFormRadio;

InputsWrap.propTypes = {
  children: PropTypes.node.isRequired,
  labelTitle: PropTypes.string.isRequired,
};

InputRadio.defaultProps = {
  disabled: false,
  hasError: false,
};

InputRadio.propTypes = {
  labelText: PropTypes.string.isRequired,
  inputName: PropTypes.string.isRequired,
  inputId: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
};
